<ng-container *ngIf="{context: context$ | async, isInfluencer: isInfluencer$ | async} as vm">
  <!-- In the top bar: the navbar's own project dropdown, unchanged in look. -->
  <ng-container *ngIf="variant === 'navbar'">
    <button type="button" class="nav-link dropdown-toggle d-flex align-items-center sn-project-toggle" data-sn-project-toggle
            aria-haspopup="true" [attr.aria-expanded]="open" (click)="toggle()" (mouseenter)="openOnHover()">
      <span class="project-logo mr-1">
        <img *ngIf="!vm.context.project?.image" [src]="imageDefault" [alt]="vm.context.project?.title || ''">
        <span *ngIf="vm.context.project?.image" [style.background-image]="'url(' + vm.context.project.image + ')'"></span>
      </span>
      <span class="project-dropdown-title" [title]="vm.context.project?.title || ''">{{ vm.context.project?.title || '…' }}</span>
    </button>
    <span *ngIf="vm.context.project && !vm.isInfluencer" class="edit-project">
      <button type="button" class="btn btn-icon" title="Edit project" aria-label="Edit project" (click)="edit($event)">
        <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
      </button>
    </span>
    <div class="dropdown-menu projects-list-dropdown">
      <ng-container *ngTemplateOutlet="list"></ng-container>
    </div>
  </ng-container>

  <!-- In the side menu: a full-width row, or an avatar in the rail. -->
  <ng-container *ngIf="variant !== 'navbar'">
    <button type="button" class="sn-project" [class.sn-project--rail]="variant === 'rail'" data-sn-project-toggle
            aria-haspopup="true" [attr.aria-expanded]="open"
            [attr.aria-label]="vm.context.inProjectContext ? 'Project: ' + (vm.context.project?.title || '') : 'Select a project'"
            [title]="vm.context.inProjectContext ? (vm.context.project?.title || '') : 'Select a project'"
            (click)="toggle()">
      <span class="sn-project__avatar">
        <img *ngIf="vm.context.inProjectContext && vm.context.project?.image" [src]="vm.context.project.image" alt="">
        <i *ngIf="!(vm.context.inProjectContext && vm.context.project?.image)" class="fa-solid fa-folder-open" aria-hidden="true"></i>
      </span>
      <span *ngIf="variant === 'sidebar'" class="sn-project__text">
        <span class="sn-project__caption">{{ vm.context.inProjectContext ? 'Project' : 'Projects' }}</span>
        <span class="sn-project__title">{{ vm.context.inProjectContext ? (vm.context.project?.title || '…') : 'Select a project' }}</span>
      </span>
      <i *ngIf="variant === 'sidebar'" class="fa-solid fa-chevron-down sn-project__chevron" aria-hidden="true"></i>
    </button>
    <button *ngIf="variant === 'sidebar' && vm.context.inProjectContext && vm.context.project && !vm.isInfluencer"
            type="button" class="sn-icon-button sn-project__edit" title="Edit project" aria-label="Edit project"
            (click)="edit($event)">
      <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
    </button>
    <div *ngIf="open" class="sn-project__panel" [class.sn-project__panel--rail]="variant === 'rail'">
      <ng-container *ngTemplateOutlet="list"></ng-container>
    </div>
  </ng-container>

  <ng-template #list>
    <div class="project-search">
      <input type="search" class="form-control" placeholder="Search projects..." aria-label="Search projects"
             [ngModel]="search" (ngModelChange)="onSearch($event)">
    </div>
    <div class="projects-list-option">
      <button *ngIf="variant !== 'navbar'" type="button" class="dropdown-item sn-project__all" (click)="allProjects()">
        <i class="fa-solid fa-folder-open fa-fw" aria-hidden="true"></i> All projects
      </button>
      <button *ngFor="let project of projects; trackBy: trackById" type="button" class="dropdown-item"
              [class.active]="project.id === vm.context.projectId" (click)="choose(project.id, vm.isInfluencer)">
        <span class="image-wrapper">
          <img [src]="project.image || imageDefault" alt="">
          {{ project.title }}
        </span>
      </button>
      <div *ngIf="!projects.length && loaded" class="dropdown-item text-muted text-center">No projects found</div>
      <div *ngIf="projects.length >= 20" class="dropdown-item text-muted text-center small">
        Showing first 20 — use search to find more
      </div>
    </div>
  </ng-template>
</ng-container>
